import { Outlet, createFileRoute } from '@tanstack/react-router';
import { LayoutWithNavbar } from '~/components/layout/layout-with-navbar';

export const Route = createFileRoute('/_auth/_main-navigation')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LayoutWithNavbar>
      <Outlet />
    </LayoutWithNavbar>
  );
}
